import downloadThumbTwo from '../../assets/images/limena/bannerethnix.png';

function DownloadHomeEthnix({ className }) {
    return (
        <>
            <section className={`appie-download-3-area pt-100 ${className || ''}`} id="download">
                <div className="container">
                    <div className="row">
                        <a href="https://ethnixgroup.com"><img src={downloadThumbTwo} alt="" /></a>

                      
                    </div>
                </div>
            </section>
        </>
    );
}

export default DownloadHomeEthnix;
